import { Expose, Type } from '@nts/std/serialization';
import { AttachmentIdentity } from "./attachment.identity";
import { OperationState } from '@nts/std/types';
import { AttachmentIdentityInterface, OperationStateResultDtoInterface } from '@nts/std/interfaces';

export class OperationStateResultDto implements OperationStateResultDtoInterface {

    constructor() {
        this.attachmentIdentities = [];
    }

    @Expose()
    currentOperationState: OperationState

    @Expose()
    @Type(() => AttachmentIdentity)
    attachmentIdentities: AttachmentIdentityInterface[]

}
